const CART_KEY = 'estilobazar_cart';
const FAV_KEY = 'estilobazar_favs';

export function getCart() {
  try {
    const data = localStorage.getItem(CART_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
}

export function saveCart(cart) {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    window.dispatchEvent(new CustomEvent('cart-updated', { detail: cart }));
  } catch (e) {
    console.error('Erro ao salvar carrinho', e);
  }
}

export function addToCart(product, quantityToAdd = 1) {
  const cart = getCart();
  const maxStock = (typeof product.stock === 'number' && product.stock >= 0) ? product.stock : 1;
  const existing = cart.find(item => item.id === product.id);
  
  if (existing) {
    const currentQty = existing.quantity || 1;
    if (currentQty + quantityToAdd > maxStock) {
      showToast(`Ops! Restam apenas ${maxStock} unidade(s) de "${product.title}" em estoque. 📦`);
      return false;
    }
    existing.quantity = currentQty + quantityToAdd;
    existing.maxStock = maxStock;
  } else {
    if (quantityToAdd > maxStock) {
      showToast(`Ops! Restam apenas ${maxStock} unidade(s) de "${product.title}" em estoque. 📦`);
      return false;
    }
    cart.push({ ...product, quantity: quantityToAdd, maxStock });
  }
  
  saveCart(cart);
  showToast(`"${product.title}" adicionado ao carrinho! ✨`);
  return true;
}

export function updateCartQuantity(productId, delta) {
  const cart = getCart();
  const item = cart.find(i => i.id === productId);
  if (!item) return;

  const maxStock = (typeof item.stock === 'number' && item.stock >= 0) ? item.stock : (item.maxStock || 1);
  const currentQty = item.quantity || 1;
  const targetQty = currentQty + delta;

  if (targetQty <= 0) {
    removeFromCart(productId);
    return;
  }

  if (targetQty > maxStock) {
    showToast(`Estoque máximo atingido! Restam apenas ${maxStock} unidade(s) de "${item.title}". 📦`);
    return;
  }

  item.quantity = targetQty;
  saveCart(cart);
}

export function removeFromCart(productId) {
  let cart = getCart();
  const item = cart.find(i => i.id === productId);
  cart = cart.filter(i => i.id !== productId);
  saveCart(cart);
  if (item) {
    showToast(`"${item.title}" removido do carrinho.`);
  }
}

export function clearCart() {
  saveCart([]);
}

export function getFavorites() {
  try {
    const data = localStorage.getItem(FAV_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
}

export function toggleFavorite(product) {
  let favs = getFavorites();
  const isFav = favs.some(item => item.id === product.id);
  if (isFav) {
    favs = favs.filter(item => item.id !== product.id);
    showToast('Removido dos seus favoritos.');
  } else {
    favs.push(product);
    showToast(`"${product.title}" salvo nos favoritos! 💖`);
  }
  try {
    localStorage.setItem(FAV_KEY, JSON.stringify(favs));
    window.dispatchEvent(new CustomEvent('favs-updated', { detail: favs }));
  } catch (e) {
    console.error('Erro ao salvar favoritos', e);
  }
}

export function showToast(message) {
  let container = document.querySelector('.toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.innerHTML = `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C4E6C5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
    <span>${message}</span>
  `;

  container.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(50px)';
    toast.style.transition = 'all 0.3s ease';
    setTimeout(() => toast.remove(), 300);
  }, 3200);
}
